import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
// import {groupsSteps} from "./TourUtils";
import TourBase from "./tour-base/TourBase";
import TourStepContentSmall from "./TourStepContentSmall";

class BunkeyGroupsTour extends Component {
  render() {
    const { onRequestClose, onChangePage, tourGroups, intl } = this.props;
    const savedColor = localStorage.getItem("primaryColor");
    var groupsSteps = [];
    if (tourGroups && tourGroups.length !== 0) {
      tourGroups.forEach(r => {
        r.content = (
          <TourStepContentSmall
            title={intl.formatMessage({ id: "groups_" + r.title })}
            subtitle={intl.formatMessage({ id: "groups_" + r.description })}
          />
        );
        groupsSteps.push({ ...r });
      });
    }
    return (
      <React.Fragment>
        {groupsSteps && groupsSteps.length > 0 && (
          <TourBase
            accentColor={savedColor}
            identifier="groups_tour"
            steps={groupsSteps}
            onRequestClose={() => {
              if (onRequestClose) onRequestClose();
            }}
            onChangePage={onChangePage}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.authUser.user,
    token: state.authUser.token,
    tourGroups: state.tours.tourGroups
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(BunkeyGroupsTour))
);
